/**
 * 選考管理の全体ステータス値
 * 選考管理全体の進行状況を表す
 */
export const MANAGEMENT_OVERALL_STATUS_VALUES = {
  active: 'active',
  completed: 'completed',
  archived: 'archived',
  rejected: 'rejected',
} as const;

/**
 * 選考管理の全体ステータス選択肢
 * UIでのドロップダウン表示などに使用
 */
export const MANAGEMENT_OVERALL_STATUS_OPTIONS = [
  {label: '進行中', value: MANAGEMENT_OVERALL_STATUS_VALUES.active},
  {label: '内定獲得', value: MANAGEMENT_OVERALL_STATUS_VALUES.completed},
  {label: '辞退', value: MANAGEMENT_OVERALL_STATUS_VALUES.archived},
  {label: '落選', value: MANAGEMENT_OVERALL_STATUS_VALUES.rejected},
] as const;

/**
 * 選考予定の結果値
 * 各選考予定の結果を表す
 *
 * - pending: 結果待ち
 * - accepted: 通過
 * - completed: 完了
 * - rejected: 落選
 * - declined: 辞退
 */
export const PROGRESS_RESULT_VALUES = {
  pending: 'pending',
  accepted: 'accepted',
  completed: 'completed',
  rejected: 'rejected',
  declined: 'declined',
} as const;

/**
 * 選考予定の結果選択肢
 * UIでのドロップダウン表示などに使用
 */
export const PROGRESS_RESULT_OPTIONS = [
  {label: '未選択', value: ''},
  {
    label: '結果待ち',
    value: PROGRESS_RESULT_VALUES.pending,
  },
  {
    label: '通過',
    value: PROGRESS_RESULT_VALUES.accepted,
  },
  {
    label: '完了',
    value: PROGRESS_RESULT_VALUES.completed,
  },
  {
    label: '落選',
    value: PROGRESS_RESULT_VALUES.rejected,
  },
  {
    label: '辞退',
    value: PROGRESS_RESULT_VALUES.declined,
  },
] as const;
